import type { TicketStatus } from './ticket-state-machine'

export function canAnswerClarificationQuestions({
  isExpert,
  status,
  currentUserId,
  submitterId,
  hasQuestions,
}: {
  isExpert: boolean
  status: TicketStatus
  currentUserId: string
  submitterId: string
  hasQuestions: boolean
}) {
  return !isExpert && status === 'NEEDS_INFO' && hasQuestions && currentUserId === submitterId
}

export function canSeeClarificationWaitingState({
  isExpert,
  status,
  hasQuestions,
}: {
  isExpert: boolean
  status: TicketStatus
  hasQuestions: boolean
}) {
  return isExpert && status === 'NEEDS_INFO' && hasQuestions
}
